/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { User } from '../models/User';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AuthenticationService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get current user
     * @returns any Successful request
     * @throws ApiError
     */
    public authWhoami(): CancelablePromise<{
        message: {
            message: 'Successful request';
        };
        success: boolean;
        error: any;
        result: User;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/auth/whoami',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal error`,
            },
        });
    }
    /**
     * Delete current user
     * @returns any Successful request
     * @throws ApiError
     */
    public authDel(): CancelablePromise<{
        message: {
            message: 'Successful request';
        };
        success: boolean;
        error: any;
        result: {
            /**
             * ID of the user
             */
            id: string;
            _object: 'user';
        };
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/v1/auth/me',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal error`,
            },
        });
    }
    /**
     * Update the fields of the current user
     * @param id
     * @param requestBody Email and password.
     * @returns any Successful request
     * @throws ApiError
     */
    public authPatch(
        id: string,
        requestBody: {
            forename?: string;
            surname?: string | null;
        },
    ): CancelablePromise<{
        message: {
            message: 'Successful request';
        };
        success: boolean;
        error: any;
        result: User;
    }> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/v1/auth/me',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal error`,
            },
        });
    }
}
